<template>
    <div class="qr-toast-region" role="status" aria-live="polite">
        <transition name="qr-toast">
            <p v-if="noticeKey" :key="noticeKey" class="qr-toast" data-test="qr-toast">
                {{ $t(noticeKey, noticeParams) }}
            </p>
        </transition>
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { QR_TOAST_DURATION_MS } from '../../constants/qr';

const store = useStore();
const notice = computed(() => store.getters['qr/notice']);
const noticeKey = computed(() => (typeof notice.value === 'string' ? notice.value : notice.value?.key));
const noticeParams = computed(() => (typeof notice.value === 'object' ? notice.value.params : undefined));
let timer = null;

watch(notice, value => {
    clearTimeout(timer);
    if (value) timer = setTimeout(() => store.dispatch('qr/clearNotice'), QR_TOAST_DURATION_MS);
}, { immediate: true });

onBeforeUnmount(() => clearTimeout(timer));
</script>

<style scoped>
.qr-toast-region {
    position: fixed;
    right: 0;
    bottom: calc(16px + env(safe-area-inset-bottom) + var(--qr-connection-space, 0px));
    left: 0;
    z-index: 50;
    display: flex;
    justify-content: center;
    padding: 0 16px;
    pointer-events: none;
}

.qr-toast {
    width: 100%;
    max-width: 448px;
    padding: 16px 20px;
    border-radius: 12px;
    background: #222;
    color: #fff;
    font-family: sofia-pro, Helvetica, Arial, sans-serif;
    font-size: 15px;
    line-height: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.qr-toast-enter-active,
.qr-toast-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}

.qr-toast-enter-from,
.qr-toast-leave-to {
    opacity: 0;
    transform: translateY(8px);
}
</style>
